/* Metacards v3.8: small behaviours for store pages. No dependencies. */
(function () {
  // Sticky filter bar sits right under the header.
  function headerBottom() {
    var el = document.querySelector('.mc-nav');
    return el ? Math.max(0, Math.round(el.getBoundingClientRect().bottom)) : 0;
  }
  var bars = document.querySelectorAll('.mp-filters');
  if (bars.length) {
    var setTop = function () { var t = headerBottom(); bars.forEach(function (b) { b.style.setProperty('--mp-top', t + 'px'); }); };
    setTop(); addEventListener('resize', setTop); addEventListener('scroll', setTop, { passive: true });
  }

  // Sort select changes the URL (?sort_by=).
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-mp-sort]');
    if (!s) return;
    var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    location.href = u.toString();
  });

  // 3D tilt on product tiles, mouse only (touch stays flat so scrolling is smooth).
  if (matchMedia('(hover:hover)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var last = null;
    document.addEventListener('pointermove', function (e) {
      var c = e.target.closest && e.target.closest('.mp-card');
      var t = c && c.querySelector('.mp-card__tl');
      if (last && last !== t) { last.style.removeProperty('--rx'); last.style.removeProperty('--ry'); }
      last = t; if (!t) return;
      var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      t.style.setProperty('--ry', (x * 16).toFixed(2) + 'deg');
      t.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg');
    });
  }

  // Footer columns: open on desktop, first one open on phones.
  var fq = matchMedia('(min-width:900px)');
  function fsync() { document.querySelectorAll('.mp-fcol details').forEach(function (d, i) { d.open = fq.matches || i === 0; }); }
  fsync(); fq.addEventListener && fq.addEventListener('change', fsync);

  // Search: popular chips fill the box and submit.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mp-q]');
    if (!b) return;
    var f = b.closest('[data-mp-search]'); if (!f) return;
    var i = f.querySelector('input[name=q]'); i.value = b.getAttribute('data-mp-q');
    var form = f.querySelector('form'); form && form.submit();
  });
})();
